import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="hideable"
export default class extends Controller {
  static values = {
    delay: { type: Number, default: 5000 }
  };

  connect() {
    // Auto-hide after delay unless this is a programmatic toast managed by the
    // toast controller.
    if (!this.element.classList.contains('toast')) {
      this.hideTimeout = setTimeout(() => {
        this.hide();
      }, this.delayValue);
    }
  }

  disconnect() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
  }

  hide() {
    this.element.classList.add('flash--hiding');

    // Remove element after animation
    this.element.addEventListener('animationend', () => {
      this.element.remove();
    }, { once: true });
  }

  // Keep visible on hover
  keepVisible() {
    if (this.hideTimeout) {
      clearTimeout(this.hideTimeout);
    }
  }

  // Resume auto-hide
  resumeHide() {
    this.hideTimeout = setTimeout(() => {
      this.hide();
    }, this.delayValue);
  }
}
